import { getCurrentFramework } from './getCurrentFramework.js';
import { mark } from './lib/mark.js';
import { PRIVACY_MANAGER_AUSTRALIA, PRIVACY_MANAGER_USNAT, PRIVACY_MANAGER_TCFV2 } from './lib/sourcepointConfig.js';
import { init as init$1, willShowPrivacyMessage as willShowPrivacyMessage$1 } from './sourcepoint.js';

const init = (framework, pubData) => {
  mark("cmp-init");
  init$1(framework, pubData);
};
const willShowPrivacyMessage = () => willShowPrivacyMessage$1;
function showPrivacyManager() {
  switch (getCurrentFramework()) {
    case "tcfv2":
      window._sp_?.gdpr?.loadPrivacyManagerModal?.(PRIVACY_MANAGER_TCFV2);
      break;
    case "usnat":
      window._sp_?.usnat?.loadPrivacyManagerModal?.(PRIVACY_MANAGER_USNAT);
      break;
    case "aus":
      window._sp_?.ccpa?.loadPrivacyManagerModal?.(PRIVACY_MANAGER_AUSTRALIA);
      break;
  }
}
const CMP = {
  init,
  willShowPrivacyMessage,
  showPrivacyManager
};

export { CMP };
